<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="400px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed"
  >
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="125px">
      <el-form-item
        label="行业管理名称："
        prop="className">
        <el-input v-model="info.className"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'EditCategoryModal',
  components: {},
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: {
        parent: null,
        classId: null,
        className: ''
      },
      rules: {
        className: [
          { required: true, message: '请输入行业管理名称', trigger: 'blur' },
          { max: 30, message: '长度最多 30 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title() {
      const classId = this.info.classId
      const level = this.info.level
      const parent = this.info.parent
      const lvl = classId ? (level === 1 ? '一级' : '二级') : (parent ? '二级' : '一级')
      return (this.info.classId ? '编辑' : '新增') + lvl + '行业管理'
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = {
        parent: null,
        classId: null,
        className: ''
      }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.info.classId ? 'updatecategory' : 'addcategory'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: this.info,
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    add(options = {}) {
      this.info = {
        ...this.info,
        parent: options.classId || null
      }
      this.toggleModal(true)
    },
    update(options = {}) {
      this.info = {
        ...this.info,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
